/*
 * Copyright © 2015-2021 Serenova, LLC. All rights reserved.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AddFilter } from './AddFilterField';
import { SelectInputField } from './SelectInputField';
import { InputField, DetailHeader, ConfirmationWrapper } from 'cx-ui-components';

const InQueueFieldWrapper = styled.div`
  display: flex;
  margin-left: 10px;
`;
const StyledDetailHeader = styled(DetailHeader)`
  flex-grow: 1;
  color: #656565 !important;
  margin: 0px !important;
`;
const SearchQueryHeaderWrapper = styled.div`
  display: flex;
  margin: 10px 0 10px 5px;
`;
const RemoveLevelBtn = styled.span`
  display: inline-block;
  font-size: 14px;
  color: #3498db;
  cursor: pointer;
  :hover {
    color: #07487a;
  }
`;

export const SearchQueryLevel = ({ index, basicQuery, fields, level, addFilterOptions }) => {
  const doesLevelContainFilterItem =
    level &&
    level.some(
      (levelItem) =>
        levelItem &&
        levelItem[1] &&
        levelItem[1].some((lists) => {
          const a = lists.list[1]['map'] || lists.list[1]['set'];
          return a && a.length > 0;
        })
    );

  return (
    <Fragment>
      <SearchQueryHeaderWrapper>
        <StyledDetailHeader text={`Search query level ${index}`} />
        {doesLevelContainFilterItem ? (
          <ConfirmationWrapper
            actionBtnType="button"
            mainText="This query level is not empty. Removing this level will modify the query. Continue?"
            confirmBtnCallback={() => fields.remove(index)}>
            <RemoveLevelBtn>(remove level)</RemoveLevelBtn>
          </ConfirmationWrapper>
        ) : (
          <RemoveLevelBtn
            onClick={(e) => {
              e.stopPropagation();
              fields.remove(index);
            }}>
            (remove level)
          </RemoveLevelBtn>
        )}
      </SearchQueryHeaderWrapper>
      <InQueueFieldWrapper>
        <InputField
          name={`basicQuery[${[index]}].map[${[0]}][${[1]}]`}
          label="If call is not answered within"
          componentType="input"
          dataType="number"
          minValue="1"
          labelWidth="190px"
          disabled={false}
          alignInptTextToRight
          integersOnlyAllowed
          data-automation="callNotAnswered"
        />
        <SelectInputField
          name={`basicQuery[${[index]}][selectedFilters][inQueueTimeFormat]`}
          options={[{ label: 'seconds', value: 'seconds' }, { label: 'minutes', value: 'minutes' }]}
          disabled={false}
          data-automation="queueQueryAddFilterList"
          required
        />
      </InQueueFieldWrapper>
      <AddFilter
        index={index}
        options={addFilterOptions}
        disabled={addFilterOptions.length === 0}
        basicQuery={basicQuery}
      />
    </Fragment>
  );
};

SearchQueryLevel.propTypes = {
  index: PropTypes.number,
  basicQuery: PropTypes.object,
  addFilterOptions: PropTypes.array,
};
